import { launchAppointmentEncounter } from "../../../api/Scheduling/appointments";
import { editEncounter, editEncounterIntakeQuestions } from "../../../apps/api/Encounter";
import { getSignature } from "../../../Zoom/functions";
import { loadAppointmentEncounter } from "./appointmentEncounter";
import { subjectPatientRef } from "./statusLabels";

export function appointmentChannel(appointment, encounter) {
  return encounter?.intakeQuestions?.preferredChannel || appointment?.bookingContext?.preferredChannel || "";
}

export function communicationMethodLabel(channel) {
  if (channel === "video/chat") return "Video";
  if (channel === "phone") return "Phone";
  return "Not recorded";
}

export function canLaunchAppointment({ appointment, practitionerRef, readOnly = false, isProviderAppointment = false }) {
  return Boolean(
    appointment &&
    !readOnly &&
    !isProviderAppointment &&
    appointment.status === "booked" &&
    practitionerRef &&
    appointment.practitionerRefs?.includes(practitionerRef) &&
    (appointment.bookingContext || appointment.encounterId)
  );
}

export async function openEncounterSession({
  record,
  appointment,
  practitionerRef,
  patientName,
  navigate,
  readOnly = false,
  isProviderAppointment = false,
}) {
  const patientRef = subjectPatientRef(appointment);
  if (!record?.id) throw new Error("The linked encounter is unavailable.");
  const currentPractitioner = record.participant?.find((participant) => participant.period?.end === null)?.individual?.reference;
  if (record.status === "finished" || readOnly || isProviderAppointment || !appointment.practitionerRefs?.includes(practitionerRef) || (currentPractitioner && currentPractitioner !== `Practitioner/${practitionerRef}`)) {
    navigate(`/app/encounter-details?encounterId=${encodeURIComponent(record.id)}`);
    return;
  }
  if (record.status === "planned") {
    await editEncounter({ encounterId: record.id, status: "in-progress-appointment", practitionerId: practitionerRef });
  }
  if (record.intakeQuestions?.preferredChannel === "video/chat") {
    const topic = record.intakeQuestions?.zoomTopic || `appt-${appointment.appointmentId}`;
    const password = record.intakeQuestions?.zoomPassword || crypto.randomUUID().replace(/-/g, "");
    if (!record.intakeQuestions?.zoomPassword) {
      await editEncounterIntakeQuestions({ encounterId: record.id, payload: { intakeQuestions: { zoomTopic: topic, zoomPassword: password } } });
    }
    const signature = await getSignature({ topic, role: 1, password });
    navigate("/app/zoom-meeting-create", { state: { topic, password, sessionToken: signature?.data?.sessionToken, encounterId: record.id, patientId: patientRef, launchedFrom: "appointment" } });
    return;
  }
  navigate("/app/interaction", { state: { encounterId: record.id, patientId: patientRef, patientName, practitionerId: practitionerRef, proceedWith: "COMPLETE_CALL", launchedFrom: "appointment" } });
}

export async function launchOrOpenAppointment({
  appointment,
  organizationRef,
  practitionerRef,
  patientName,
  navigate,
  readOnly = false,
  isProviderAppointment = false,
}) {
  let record;
  if (appointment.encounterId) {
    record = await loadAppointmentEncounter(appointment, organizationRef);
  } else {
    if (!appointment.bookingContext) {
      throw new Error("This older appointment has no source encounter reference. Its existing encounter must be linked before it can be opened.");
    }
    record = await launchAppointmentEncounter({ appointment, organizationRef, practitionerRef });
  }
  await openEncounterSession({ record, appointment, practitionerRef, patientName, navigate, readOnly, isProviderAppointment });
  return record;
}
